import { utc } from 'moment';
import { encryptAuthHeader } from './EncryptionHelper';
import jwt_decode from 'jwt-decode';

export function getTokenHeader(accessToken, refreshToken) {
  if (accessToken) {
    const authHeader = {
      token: accessToken,
      refreshToken: refreshToken? refreshToken : null,
      timestamp: utc().format(),
    };

    const encryptedHeader = encryptAuthHeader(JSON.stringify(authHeader));

    return {
      Authorization: `Bearer ${encryptedHeader}`,
    };
  }
  return {};
}

export function isTokenValid(token) {
  const decoded = jwt_decode(token);
  return !!(decoded && Date.now() < decoded.exp*1000);
}